import api from './api';

// 用户登录
export const login = async (email, password) => {
  const formData = new FormData();
  formData.append('username', email); // OAuth2PasswordRequestForm期望username字段，但实际传入邮箱
  formData.append('password', password);
  
  try {
    const response = await api.post('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '登录失败');
  }
};

// 用户注册
export const register = async (email, password) => {
  try {
    const response = await api.post('/auth/register', {
      email,
      password,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '注册失败');
  }
};

// 重置密码
export const resetPassword = async (oldPassword, newPassword) => {
  try {
    const response = await api.post('/auth/reset-password', {
      old_password: oldPassword,
      new_password: newPassword,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '重置密码失败');
  }
};
